export const EVENT = {
  CLICKED: 'clicked',
  CLOSED: 'closed',
  CHANGED: 'changed',
  SHOW_POLICY: 'show-policy',
  SHOW_LOADING: 'show-loading',
  SHOW_WARNING: 'show-warning'
}



// WEBPACK FOOTER //
// ./src/constants/event.js